import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { firstResponseError } from '@/utils/errors';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import fetch from '@/hooks/fetch';
import {
  fetchConfiguration,
  hideAutoApproval,
  toggleAutoApprovalConfiguration,
  updateConfigurationProperties,
} from '@/configurations/actions';
import { configurationCodes } from '@/configurations/constants';

const UsersAutoApprovalDialog = ({
  approval,
  fetchAutoApproval,
  hide,
  readStatus,
  readErrors,
  saveErrors,
  saveStatus,
  theme,
  toggleApproval,
  updateProperties,
}) => {
  const intl = useIntl();
  fetch.useFetchByCode(fetchAutoApproval, 'all', configurationCodes.DEFAULT_APPROVAL, states.NONE);
  return (
    <Dialog
      className="aridhia-auto-approval-dialog"
      error={firstResponseError([...readErrors, ...saveErrors])}
      icon="cog"
      inProgress={saveStatus === states.PENDING}
      message={`configurations.approval.${approval ? 'require.admin.message' : 'auto.approve.message'}`}
      minimumDataEntryMet={readStatus === states.SUCCESS}
      onClose={hide}
      onDismiss={() => updateProperties('all', configurationCodes.DEFAULT_APPROVAL, { saveErrors: [] })}
      onSave={() => toggleApproval('all')}
      saveMessageId={`configurations.approval.${approval ? 'require.admin.button' : 'auto.approve.button'}`}
      theme={theme}
      title={intl.formatMessage({ id: 'configurations.approval.title' })}
    />
  );
};

const mapStateToProps = ({
  configurations: { configurations },
}) => {
  const configuration = findResult(configurations, 'all', configurationCodes.DEFAULT_APPROVAL) || {
    ...readStates,
    ...saveStates,
  };

  return ({
    approval: configuration?.value?.value,
    readErrors: configuration.readErrors,
    readStatus: configuration.readStatus,
    saveErrors: configuration.saveErrors,
    saveStatus: configuration.saveStatus,
  });
};

const mapDispatchToProps = {
  fetchAutoApproval: fetchConfiguration,
  hide: hideAutoApproval,
  toggleApproval: toggleAutoApprovalConfiguration,
  updateProperties: updateConfigurationProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersAutoApprovalDialog);
